import React, { useState, useEffect } from "react";
import { useFormik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import api from "../../services/axiosConfig";
import { BASE_URL, GET_USER } from "../../constant-value";
import { validationUserSchema } from "../../constant-value/schema";
// تاریخ شمسی
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import { setUser } from "../../redux/user/userSlice";
import { motion } from "framer-motion";
import { FaUserClock, FaCrown, FaSignInAlt } from "react-icons/fa";
import { useNavigate } from "react-router";
import styles from "./EditProfileForm.module.css";


const EditProfileForm = () => {
  // const userId = useSelector((state) => state.user.userId);
  const user = useSelector((state) => state.user.user);
  const dispatch = useDispatch();
  const [formData, setFormData] = useState({});
  const [selectedFile, setSelectedFile] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();

  // دریافت اطلاعات کاربر
  useEffect(() => {
    api
      .get(`/${GET_USER}${user.userId}`)
      .then((result) => setFormData(result.data))
      .catch((error) => console.log("catch: ", error))
      .finally(() => setIsLoading(false));
  }, [user.userId]);

  const message = (msg, type) => {
    if (type === "warn") toast.warning(msg, { autoClose: 1500 });
    else toast.success(msg, { autoClose: 1500 });
  };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      id: user.userId,
      fullName: formData.fullName || "",
      userName: formData.userName || "",
      gender: formData.gender ?? true,
      birthDate: formData.birthDate || "",
      registerDate: formData.registerDate || "",
      expireDate: formData.expireDate || "",
      lastLoginDate: formData.lastLoginDate || "",
      imageUrl: formData.imageUrl || "",
    },
    validationSchema: validationUserSchema,
    onSubmit: async (values, { setSubmitting }) => {
      try {
        const fd = new FormData();

        // فیلدها
        Object.keys(values).forEach((key) => {
          fd.append(key, values[key] ?? "");
        });

        // فایل تصویر
        if (selectedFile) {
          if (!selectedFile.type.startsWith("image/")) {
            toast.error("فقط فایل تصویری مجاز است!");
            return;
          }
          if (selectedFile.size > 2 * 1024 * 1024) {
            toast.error("حجم تصویر نباید بیشتر از 2 مگابایت باشد!");
            return;
          }
          fd.append("profileImage", selectedFile);
        }

        const res = await api.put(`/api/users/${user.userId}`, fd, {
          headers: { "Content-Type": "multipart/form-data" },
        });

        if (res.data.isSuccess) {
          message(res.data.message, "success");
          // 🔹 تبدیل FormData به Object
          const plainObj = formDataToObject(fd);
          // 🔹 تبدیل Object به مدل جدید
          const newUser = mapToUserDto(plainObj, res.data.data.fileName);
          // 🔹 ذخیره در Redux
          // dispatch(setUserIdFromBody(newUser));

          dispatch(setUser(newUser));
          navigate('/')
        }
        else message(res.data.message, "warn");
      } catch (err) {
        console.error("Error updating profile:", err);
        toast.error("خطا در ذخیره اطلاعات!");
      } finally {
        setSubmitting(false);
      }
    },
  });

// تابع کمکی: FormData -> Object
function formDataToObject(formData) {
  const obj = {};
  formData.forEach((value, key) => {
    obj[key] = value;
  });
  return obj;
}

// مپر برای تبدیل به مدل جدید
function mapToUserDto(oldUser,fileNAme) {
  return {
    userId: oldUser.id,
    userName: oldUser.userName,
    fullName: oldUser.fullName,
    gender:
      oldUser.gender === true || oldUser.gender === "true"
        ? true
        : oldUser.gender === false || oldUser.gender === "false"
        ? false
        : null,
    birthDate: oldUser.birthDate || null,
    registerDate: oldUser.registerDate || null,
    expireDate: oldUser.expireDate || null,
    imageUrl: BASE_URL + '/Images/Profile/' + fileNAme,
    email: null, // چون در دیتای قدیمی وجود نداره
  };
}
  

  if (isLoading) {
    return (
      <div className="container mt-5 text-center">
        <div className="py-5">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
          <p className="mt-3">در حال دریافت اطلاعات کاربر...</p>
        </div>
      </div>
    );
  }
  
  return (
    <div className="container mt-4">
      <div className="row justify-content-center">
        <div className="col-12 col-md-8 col-lg-6">
          <form onSubmit={formik.handleSubmit}>
            <div className="card shadow-sm border-0">
  
              <div className="card-body">
  
                {/* 🟦 کارت‌های اطلاعات سیستمی با اسکرول افقی در موبایل */}
                <div className={`${styles.systemCardsWrapper} mb-4`}>
                  <div className="row flex-nowrap g-3 text-center">
                    <motion.div
                      className={`col-7 col-sm-5 col-md-4 ${styles.cardCol}`}
                      initial={{ opacity: 0, scale: 0.8 }}
                      animate={{ opacity: 1, scale: 1 }}
                      transition={{ delay: 0.1, duration: 0.4 }}
                    >
                      <div className="p-3 rounded-4 shadow-sm" style={{ backgroundColor: "#e3f2fd" }}>
                        <FaUserClock size={26} className="text-primary mb-2" />
                        <h6 className="text-primary fw-bold mb-1">تاریخ عضویت</h6>
                        <div className="fw-semibold">{formik.values.registerDate || "-"}</div>
                      </div>
                    </motion.div>
    
                    <motion.div
                      className={`col-7 col-sm-5 col-md-4 ${styles.cardCol}`}
                      initial={{ opacity: 0, scale: 0.8 }}
                      animate={{ opacity: 1, scale: 1 }}
                      transition={{ delay: 0.25, duration: 0.4 }}
                    >
                      {formik.values.expireDate ? (
                        // ✅ حالت عادی (اشتراک فعال)
                        <div
                          className="p-3 rounded-4 shadow-sm"
                          style={{ backgroundColor: "#e8f5e9" }}
                        >
                          <FaCrown size={26} className="text-success mb-2" />
                          <h6 className="text-success fw-bold mb-1">اتمام اشتراک</h6>
                          <div className="fw-semibold">{formik.values.expireDate}</div>
                        </div>
                      ) : (
                        // ⚠️ حالت بدون اشتراک (null)
                        <div
                          className="p-3 rounded-4 shadow-sm"
                          style={{ backgroundColor: "#fff3e0" }}
                        >
                          <FaCrown size={26} className="text-warning mb-2" />
                          <h6 className="text-warning fw-bold mb-2">اشتراک فعال نیست</h6>
                          <button
                            type="button"
                            className="btn btn-outline-warning btn-sm fw-semibold"
                            onClick={() => navigate("/subscribe")} // مسیر دلخواه برای خرید
                          >
                            💳 خرید اشتراک
                          </button>
                        </div>
                      )}
                    </motion.div>
    
                    <motion.div
                      className={`col-7 col-sm-5 col-md-4 ${styles.cardCol}`}
                      initial={{ opacity: 0, scale: 0.8 }}
                      animate={{ opacity: 1, scale: 1 }}
                      transition={{ delay: 0.4, duration: 0.4 }}
                    >
                      <div className="p-3 rounded-4 shadow-sm" style={{ backgroundColor: "#f3e5f5" }}>
                        <FaSignInAlt size={26} className="text-purple mb-2" />
                        <h6 className="text-purple fw-bold mb-1">آخرین ورود</h6>
                        <div className="fw-semibold">{formik.values.lastLoginDate || "-"}</div>
                      </div>
                    </motion.div>
                  </div>
                  <div className={styles.swipeIndicator}>↔️ اسکرول کنید</div>
                </div>

  
                <hr />
  
                {/* 🧑‍💻 تصویر پروفایل */}
                <div className="text-center mb-4">
                  <img
                    src={
                      selectedFile
                        ? URL.createObjectURL(selectedFile)
                        : formik.values.imageUrl || "/default-avatar.png"
                    }
                    alt="profile"
                    className="rounded-circle shadow-sm mb-2"
                    style={{
                      width: "120px",
                      height: "120px",
                      objectFit: "cover",
                    }}
                  />
                  <div>
                    <label className="btn btn-outline-primary btn-sm mt-2">
                      انتخاب تصویر
                      <input
                        type="file"
                        accept="image/*"
                        hidden
                        onChange={(e) => {
                          const file = e.target.files[0];
                          if (file) setSelectedFile(file);
                        }}
                      />
                    </label>
                  </div>
                </div>
  
                {/* 📝 فیلدهای ویرایش */}
                <div className="mb-3">
                  <label className="form-label">نام کامل</label>
                  <input
                    type="text"
                    className={`form-control ${
                      formik.errors.fullName && formik.touched.fullName
                        ? "is-invalid"
                        : ""
                    }`}
                    name="fullName"
                    value={formik.values.fullName}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                  {formik.errors.fullName && formik.touched.fullName && (
                    <div className="invalid-feedback">
                      {formik.errors.fullName}
                    </div>
                  )}
                </div>
  
                {/* جنسیت */}
                <div className="mb-3">
                  <label className="form-label">جنسیت</label>
                  <div>
                    <div className="form-check form-check-inline">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="gender"
                        value="true"
                        checked={formik.values.gender === true}
                        onChange={() => formik.setFieldValue("gender", true)}
                      />
                      <label className="form-check-label">مرد</label>
                    </div>
                    <div className="form-check form-check-inline">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="gender"
                        value="false"
                        checked={formik.values.gender === false}
                        onChange={() => formik.setFieldValue("gender", false)}
                      />
                      <label className="form-check-label">زن</label>
                    </div>
                  </div>
                </div>
  
                {/* تاریخ تولد */}
                <div className="mb-3">
                  <label className="form-label">تاریخ تولد</label>
                  <DatePicker
                    inputClass={`form-control ${
                      formik.errors.birthDate && formik.touched.birthDate
                        ? "is-invalid"
                        : ""
                    }`}
                    calendar={persian}
                    locale={persian_fa}
                    value={formik.values.birthDate || ""}
                    onChange={(date) =>
                      formik.setFieldValue(
                        "birthDate",
                        date ? date.format("YYYY/MM/DD") : ""
                      )
                    }
                    format="YYYY/MM/DD"
                    calendarPosition="bottom-right"
                  />
                  {formik.errors.birthDate && formik.touched.birthDate && (
                    <div className="invalid-feedback d-block">
                      {formik.errors.birthDate}
                    </div>
                  )}
                </div>
  
                {/* دکمه ذخیره */}
                <div className="d-grid mt-4">
                  <button 
                    className="btn btn-primary w-100 py-2 rounded-3 fw-bold" 
                    type="submit"
                    disabled={formik.isSubmitting}
                  >
                    {formik.isSubmitting ? (
                      <>
                        <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                        در حال ذخیره تغییرات...
                      </>
                    ) : 'ذخیره تغییرات'}
                  </button>
                  {/* <motion.button
                    type="submit"
                    className="btn btn-success btn-lg"
                    disabled={formik.isSubmitting}
                    whileHover={{ scale: 1.03 }}
                    whileTap={{ scale: 0.95 }}
                    transition={{ duration: 0.15 }}
                  >
                    ✅ ذخیره تغییرات
                  </motion.button> */}
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );  
};

export default EditProfileForm;
